var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChangeCode48Line = function SvgIconChangeCode48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 17.769h3.1v4.46h3.4v-6.16a1.502 1.502 0 0 0-.18-.74c-.02-.04-.04-.07-.06-.1-.07-.13-.16-.25-.26-.35l-6-6c-.11-.11-.23-.19-.35-.27-.03-.02-.06-.04-.1-.05-.23-.11-.48-.18-.74-.18h-12.4a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h7.63v-3.4h-7.63a1.9 1.9 0 0 1-1.9-1.9v-18.8c0-1.05.85-1.9 1.9-1.9h10.7v3.1c0 1.6 1.3 2.9 2.9 2.9l-.01-.01ZM41.7 27.909l-2.29-2.28c-.47-.47-1.23-.47-1.7 0l-9.11 9.11-.8 4.08c-.08.42.29.79.7.7l4.08-.8 9.11-9.11c.47-.47.47-1.23 0-1.7h.01Z",
    fill: "current"
  })));
};
export default SvgIconChangeCode48Line;